import React, { Suspense } from 'react'

import Field from '../../../../components/fields'
import { SectionHeader } from '../../../../components/generic'

export default function FamilyFeaturesSettings(props) {
  const { formId, homeSettings, preferredCarePlansNominative } = props

  return (
    <div style={styles.sectionContainer}>
      <SectionHeader title="Features" greyLine compact />
      <div style={styles.featureOptionsContainer}>
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          formId={formId}
          keys="familyDocuments"
          layout="no-label"
          displayLabel={false}
          compact
          label="Documents"
          type="singleCheckbox"
          values={homeSettings}
        />
        </Suspense>
        {(homeSettings?.carePlans || props?.features?.carePlans) && (
          <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys="familyCarePlans"
            layout="no-label"
            displayLabel={false}
            compact
            label={`${preferredCarePlansNominative} (inc. documents) and Risk Assessments`}
            type="singleCheckbox"
            values={homeSettings}
          />
          </Suspense>
        )}
        {(homeSettings?.carePlans || props?.features?.carePlans) && (
          <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys="familyMedications"
            layout="no-label"
            displayLabel={false}
            compact
            label="Medications"
            type="singleCheckbox"
            values={homeSettings}
          />
          </Suspense>
        )}
      </div>
    </div>
  )
}

const styles = {
  sectionContainer: {
    marginTop: 35,
    marginBottom: 15,
    width: '100%',
  },
  featureOptionsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: 8,
  },
}
